// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.time-manager-notemporaldata {
    padding: 1em;
}

div.time-manager-body {
    display: flex;
    flex-direction: column;
    height: 100%;
}

div.time-manager-toolbar {
    flex: 0 0 auto;
    margin-bottom: 0.25em;
    display: flex;
    align-items: top;
}

div.time-manager-toolbar-controls {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 0.25em;
}

div.time-manager-options-menubutton {
    flex: 0 0 auto;
    position: relative;
}

div.time-manager-toolbar-controls > *:not(:last-child) {
    margin-right: 1em;
}

div.time-manager-toolbar input,
div.time-manager-toolbar select {
    width: 6em;
}

div.time-manager-toolbar div.ToggleSwitch {
    width: 6em;
    margin-left: 0.25em;
}

span.time-manager-toolbar-block {
    display: flex;
    align-items: center;
    white-space: nowrap;
}

span.time-manager-toolbar-spacer {
    flex: 1 1 auto;
}

div.time-manager-options {
    padding: 0.25em;
    position: absolute;
    right: 0;
    border: 1px solid var(--border-color);
    background-color: var(--container-bg-color);
    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);
    z-index: 5;
}

div.time-manager-options td {
    white-space: nowrap;
}

div.time-manager-options td select {
    width: 100%;
    min-width: 12ch;
}

div.time-manager-timeline {
    flex: 1 1 auto;
}

div.time-manager-filter-warning {
    padding: 0.25em 0.5em;
    background-color: orange;
    display: flex;
    align-items: center;
}

div.time-manager-filter-warning > span.icon {
    margin-right: 0.5em;
}

div.time-manager-filter-warning > button.button {
    margin-left: 0.5em;
}`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/TimeManager.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,2CAA2C;IAC3C,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["div.time-manager-notemporaldata {\n    padding: 1em;\n}\n\ndiv.time-manager-body {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\ndiv.time-manager-toolbar {\n    flex: 0 0 auto;\n    margin-bottom: 0.25em;\n    display: flex;\n    align-items: top;\n}\n\ndiv.time-manager-toolbar-controls {\n    display: flex;\n    flex: 1 1 auto;\n    align-items: center;\n    flex-wrap: wrap;\n    padding: 0 0.25em;\n}\n\ndiv.time-manager-options-menubutton {\n    flex: 0 0 auto;\n    position: relative;\n}\n\ndiv.time-manager-toolbar-controls > *:not(:last-child) {\n    margin-right: 1em;\n}\n\ndiv.time-manager-toolbar input,\ndiv.time-manager-toolbar select {\n    width: 6em;\n}\n\ndiv.time-manager-toolbar div.ToggleSwitch {\n    width: 6em;\n    margin-left: 0.25em;\n}\n\nspan.time-manager-toolbar-block {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n}\n\nspan.time-manager-toolbar-spacer {\n    flex: 1 1 auto;\n}\n\ndiv.time-manager-options {\n    padding: 0.25em;\n    position: absolute;\n    right: 0;\n    border: 1px solid var(--border-color);\n    background-color: var(--container-bg-color);\n    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);\n    z-index: 5;\n}\n\ndiv.time-manager-options td {\n    white-space: nowrap;\n}\n\ndiv.time-manager-options td select {\n    width: 100%;\n    min-width: 12ch;\n}\n\ndiv.time-manager-timeline {\n    flex: 1 1 auto;\n}\n\ndiv.time-manager-filter-warning {\n    padding: 0.25em 0.5em;\n    background-color: orange;\n    display: flex;\n    align-items: center;\n}\n\ndiv.time-manager-filter-warning > span.icon {\n    margin-right: 0.5em;\n}\n\ndiv.time-manager-filter-warning > button.button {\n    margin-left: 0.5em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
